import axios from 'axios'
const url = process.env.REACT_APP_CHAT_URL
export interface IChatPostResponse {
	sessionId: string
	responseId?: string | null
	message: string
}

export async function newChat(data: IChatPostResponse): Promise<any> {
	return await axios.post(`${url}`, data)
}
